<template>
  <div class="external-links">
    <section class="page-content">
    <!-- 页面头部 -->
      <header class="exl-header">
        <div class="header-logo">
          <img src="../assets/images/logo2.png" class="logo-pic"/>
          <span class="logo-title">颐海统一门户</span>
        </div>
      </header>
      <!-- 页面主体 -->
      <article class="exl-content">
        <div class="exl-part" v-for="(item, index) in linkList" :key="index" v-show="item.groupSize > 0">
          <span class="exl-title">{{item.groupName}}</span>
          <div class="exl-link">
            <span class="link-title">{{item.groupSize}}</span>
            <ul class="link-ul">
              <li class="link-item table-span" v-for="(i, index) in item.linkList" :key="index" :title="i.linkName" @click="doClickLocation(i.linkAddr, i.id)">{{i.linkName}}</li>
            </ul>
          </div>
        </div>
      </article>
    </section>
  </div>
</template>
<script>
export default {
  name: 'external_links',
  data () {
    return {
      linkList: []
    }
  },
  created () {
    this.doInit()
  },
  methods: {
    doInit () {
      this.$request.post('/sso/link/getLinkInfos').then(res => {
        let { code, data } = res.data
        if (code === 'OK') {
          this.linkList = data
        }
      })
    },
    doClickLocation (url, id) {
      if (url.includes('http') || url.includes('https')) {
        window.open(`//${url.split('//')[1]}`, `sso${id}`)
      } else {
        window.open(`//${url}`, `sso${id}`)
      }
    }
  }
}
</script>
<style lang="less">
.external-links {
  .page-content {
    width: 100vw;
    height: 100vh;
    background: #F0F2F5;
    color: #333333;
    // 页面顶部
    .exl-header {
      position: absolute;
      top: 0;
      width: 100%;
      padding: 32px 160px;
      display: flex;
      display: -webkit-flex;
      justify-content: space-between;
      .header-logo{
        display: flex;
        display: -webkit-flex;
        .logo-pic {
          width: 48px;
          height: 48px;
          margin-right: 16px;
        }
        .logo-title {
          font-size: 20px;
          font-weight: 600;
          align-self:center;
        }
      }
    }
    // 页面主体
    .exl-content {
      position: absolute;
      width: 100%;
      height: 88%;
      bottom: 0;
      padding: 14px 160px 68px;
      overflow-y: auto;
      .exl-part {
        width: 100%;
        margin-bottom: 24px;
        .exl-title {
          font-size:20px;
          line-height: 28px;
          margin-bottom: 8px;
        }
        .exl-link {
          margin-top: 8px;
          border:1px solid #DDDDDD;
          padding: 16px 150px;
          position: relative;
          .link-title {
            position: absolute;
            top: 16px;
            left: 16px;
            font-size:20px;
            color: #999999;
            line-height:36px;
          }
          .link-ul {
            display: flex;
            flex-wrap: wrap;
            .link-item {
              width: 16%;
              font-size: 20px;
              color: #468FE3;
              line-height: 36px;
              margin-left: 22px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }
        }
      }
    }
  }
}
</style>
